/** `player_availability_slots.day_of_week` codes, in JS `getDay()` order. */
export const WEEKDAY_CODES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;

export type WeekdayCode = (typeof WEEKDAY_CODES)[number];

/** JS `getDay()` index of a slot's weekday code; -1 for an unknown code. */
export const weekdayIndex = (code: string): number => WEEKDAY_CODES.indexOf(code as WeekdayCode);
